import { cookiesManager } from '@/lib/utils/cookiesManager';
import { FB_ID_COOKIE } from '@petplate/ui/lib/cookies';
import { ShopifyCartProvider } from '@petplate/ui/providers/ShopifyCartProvider';
import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { v4 as uuid } from 'uuid';
import { AnalyticsProvider } from './AnalyticsProvider';
import { CurrentUserProvider } from './CurrentUserProvider';
import { DiscountProvider } from './DiscountProvider';

export const Providers = () => {
  const [fbIdentifier, setFbIdentifier] = useState<string>();

  useEffect(() => {
    const savedId = cookiesManager.get(FB_ID_COOKIE);
    if (!fbIdentifier && !savedId) {
      const newId = uuid();
      setFbIdentifier(newId);
      cookiesManager.set(FB_ID_COOKIE, newId, { expires: 30 });
    }
  }, []);

  return (
    <AnalyticsProvider>
      {/* AIDEV-NOTE: AddToCart was previously fired here on every Shopify cart line add/update,
          which is the wrong granularity (Blotout flagged the payload AND the trigger). It now
          fires once on plan accept in PetPlansForm.handleSubmit, with the canonical Edgetag
          shape (currency/value/contents). InitiateCheckout fires separately in
          PetPlanConfirmation.handleCheckout right before the redirect to Shopify. */}
      <ShopifyCartProvider>
        <CurrentUserProvider>
          <DiscountProvider>
            <Outlet />
          </DiscountProvider>
        </CurrentUserProvider>
      </ShopifyCartProvider>
    </AnalyticsProvider>
  );
};
